// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination__dFBeU","pages":"pages__3e5sw","button":"button__SqCAn"};